/* istanbul ignore file */

import {
    GET_PUBLIC_CONFIG_OPERATION,
    SET_OVERRIDE_CONFIG_OPERATION
} from 'app/store/__generated__/operations';
import { GET_OVERRIDE_CONFIG, SET_OVERRIDE_CONFIG, GET_PUBLIC_CONFIG } from './types.js';

export const doGetOverrideConfig = () => ({
    type: GET_OVERRIDE_CONFIG,
    api: { version: 2, name: 'GetOverrideConfig' }
});

export const doGetApplicationConfiguration = () => ({
    type: GET_PUBLIC_CONFIG,
    api: GET_PUBLIC_CONFIG_OPERATION
});

export const doSetOverrideConfig = (properties) => ({
    type: SET_OVERRIDE_CONFIG,
    api: SET_OVERRIDE_CONFIG_OPERATION,
    params: { properties },
    onSucceeded: ({ dispatch }) => {
        dispatch(doGetApplicationConfiguration());
        dispatch(doGetOverrideConfig());
    }
});
